import * as React from 'react'
import { FieldHookConfig, useField } from 'formik'
import {
  TextField,
  OutlinedTextFieldProps,
  formControlClasses,
  Box,
} from '@mui/material'

import { KeyboardArrowDown } from '@mui/icons-material'
import { menuProps } from '@/constants/mui'
import { DatePickerCustomComponent } from '../dates'

interface Props extends Omit<OutlinedTextFieldProps, 'variant'> {
  isDatePicker?: boolean
}

export default function InputFormikField({
  isDatePicker,
  ...props
}: Props & FieldHookConfig<string>) {
  const [field, meta, helpers] = useField(props)

  const { touched, error } = meta

  const showError = touched && Boolean(error)

  const { select, helperText, onChange } = props

  const newProps = {
    ...props,
    ...(select && {
      SelectProps: {
        IconComponent: KeyboardArrowDown,
        MenuProps: menuProps,
      },
    }),
  }

  return (
    <>
      {isDatePicker ? (
        <Box
          sx={{
            [`& .${formControlClasses.root}`]: {
              width: '100%',
            },
          }}
        >
          <DatePickerCustomComponent
            label={props.label}
            value={field.value ? new Date(field.value) : null}
            onChange={(value: Date) => {
              helpers.setValue(value.toISOString() || '')
            }}
            dayOfWeekFormatter={(day) => day}
            disabled={props.disabled}
          />
        </Box>
      ) : (
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          error={showError}
          {...newProps}
          {...field}
          multiline={props.multiline}
          rows={props.rows}
          minRows={props.minRows}
          maxRows={props.maxRows}
          onChange={(event: React.ChangeEvent<any>) => {
            onChange && onChange(event)
            helpers.setValue(event.target.value || '')
          }}
          onBlur={(event: React.FocusEvent<any>) => {
            field.onBlur(event)
            if (props.onBlur) {
              props.onBlur(event)
            }
          }}
          value={field.value ? field.value : ''}
          helperText={showError ? error : helperText}
        />
      )}
    </>
  )
}
